module.exports = __webpack_public_path__ + "img/clear-all-icon.edac269a.svg";